import { FileText, Truck } from "lucide-react";

import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";

import { FiscalLock } from "@/features/fiscal";

import Cartao from "../components/Cartao";

const UP_OPCOES = [
  ["none", "Não vincular (não despachar via UP Entrega)"],
  ["paid", "Já pago — entregador não cobra nada"],
  ["cash", "Dinheiro — entregador recebe na entrega"],
  ["card", "Cartão — entregador leva maquininha"],
  ["pix", "PIX — entregador recebe por PIX na entrega"],
];

function NotaFiscal({ d }) {
  return (
    <FiscalLock className="rounded-xl">
      <label className="flex items-start justify-between gap-3 p-3 rounded-xl border bg-emerald-50/40 dark:bg-emerald-950/10 border-emerald-200 dark:border-emerald-900 cursor-pointer">
        <span className="min-w-0">
          <span className="text-sm font-semibold flex items-center gap-1.5"><FileText className="w-4 h-4 text-emerald-600 dark:text-emerald-400" />Emitir NF automaticamente</span>
          <span className="text-[11px] text-muted-foreground block mt-0.5">Todo pedido pago com esta forma gera NFC-e sozinho. Entrega emite ao entrar em produção; os demais, no fechamento.</span>
        </span>
        <Switch checked={d.form.emitir_nf_auto} onCheckedChange={(v) => d.definir("emitir_nf_auto", v)} />
      </label>
    </FiscalLock>
  );
}

function UpEntrega({ d }) {
  const { form, definir } = d;
  return (
    <div className="p-3 rounded-xl border space-y-3">
      <div>
        <Label className="text-sm font-semibold flex items-center gap-1.5"><Truck className="w-4 h-4 text-orange-500" />Integração UP Entrega</Label>
        <p className="text-[11px] text-muted-foreground mt-0.5">Como esta forma é enviada ao entregador da UP Entrega.</p>
      </div>
      <Select value={form.up_entrega_method} onValueChange={(v) => definir("up_entrega_method", v)}>
        <SelectTrigger><SelectValue /></SelectTrigger>
        <SelectContent>{UP_OPCOES.map(([v, t]) => <SelectItem key={v} value={v}>{t}</SelectItem>)}</SelectContent>
      </Select>
      {form.up_entrega_method !== "none" && (
        <label className="flex items-center justify-between gap-3 cursor-pointer">
          <span className="text-sm">Entregador retorna ao estabelecimento
            <span className="block text-[11px] text-muted-foreground">Marque para pagamentos que envolvem troco ou maquininha.</span></span>
          <Switch checked={form.up_entrega_return} onCheckedChange={(v) => definir("up_entrega_return", v)} />
        </label>
      )}
    </div>
  );
}

/** Nota fiscal automática e entregador da UP Entrega. */
export default function SecaoIntegracoes({ d }) {
  return (
    <Cartao titulo="Nota fiscal e entregas" icone={FileText} e2e="secao-integracoes">
      <div className="space-y-3"><NotaFiscal d={d} /><UpEntrega d={d} /></div>
    </Cartao>
  );
}
